import styled from 'styled-components'

const tagColors = {
  transfer: {
    background: '#d1fae5',
    color: '#047857'
  },
  return: {
    background: '#ffe4e6',
    color: '#be123c'
  },
  purchase: {
    background: '#e0f2fe',
    color: '#0369a1'
  },
  default: {
    background: '#f1f5f9',
    color: '#475569'
  }
}

export const SuggestionTypeTag = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 999px;
  background-color: ${({ variant }) => tagColors[variant].background};
  color: ${({ variant }) => tagColors[variant].color};
  font-weight: 500;
  white-space: nowrap;
`
